var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Inline, SylController, SylPlugin } from '@syllepsis/adapter';
import { checkMarkDisable, keymapToggleMark } from '../../utils';
var NAME = 'bold';
var toggleMarkBold = keymapToggleMark(NAME);
var Bold = /** @class */ (function (_super) {
    __extends(Bold, _super);
    function Bold() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.tagName = function () { return 'strong'; };
        _this.textMatcher = [
            {
                matcher: /\*\*([^*]+)\*\*\s$/,
            },
        ];
        _this.parseDOM = [
            { tag: 'strong', priority: 25 },
            {
                tag: 'b',
                priority: 25,
                getAttrs: function (node) {
                    return node.style.fontWeight !== 'normal';
                },
            },
            /**
             * if h1 use font-weight to bolden content, it will marked as bold
             * mark cannot replaced as block when it has block node and marks
             * it will traverse it's content and insert it to paragraph
             * instead of replacing block
             */
            {
                style: 'font-weight',
                getAttrs: function (value) {
                    return /^bold(er)?$/.test(value) || +value >= 700;
                },
            },
        ];
        return _this;
    }
    return Bold;
}(Inline));
var BoldController = /** @class */ (function (_super) {
    __extends(BoldController, _super);
    function BoldController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.toolbar = {};
        _this.disable = function (editor) { return checkMarkDisable(editor.view, NAME); };
        _this.keymap = {
            'Mod-b': toggleMarkBold,
            'Mod-B': toggleMarkBold,
        };
        return _this;
    }
    return BoldController;
}(SylController));
var BoldPlugin = /** @class */ (function (_super) {
    __extends(BoldPlugin, _super);
    function BoldPlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.Controller = BoldController;
        _this.Schema = Bold;
        return _this;
    }
    return BoldPlugin;
}(SylPlugin));
export { Bold, BoldController, BoldPlugin };
//# sourceMappingURL=index.js.map